import type { BatMetadataConfigEntry } from './common/types';
import { coreFields, massUnitField } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import { refrigerantNameField } from './common/refrigerantFields';

export const soldRefrigerantMetadata = {
  displayName: msg({
    message: 'Sold products: Refrigerants',
    context: 'Activity data schema name for sold refrigerants',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    quantity: {
      displayName: msg({
        message: 'Sold refrigerants',
        context: 'The quantity of refrigerant sold.',
      }),
      externalDescription: msg({
        message: 'The quantity of refrigerant sold.',
        context: 'Sold refrigerants',
      }),
    },
    refrigerant_name: refrigerantNameField,
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
